
import { Button } from '../../../components/base/Button';

export const HeroSection = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-800 to-purple-900"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/799010887f540c25c811b9420ff99ca0.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
      
      <div className="relative z-10 container mx-auto px-6 min-h-screen flex items-center justify-center">
        <div className="text-center max-w-4xl w-full">
          <div className="mb-6">
            <span className="inline-flex items-center px-4 py-2 rounded-full bg-cyan-400/20 border border-cyan-400/30 text-cyan-300 text-sm font-medium">
              <i className="ri-shield-check-line mr-2"></i>
              Enterprise-Grade Security
            </span>
          </div>
          
          <h2 className="text-5xl md:text-7xl font-serif text-white mb-6 leading-tight">
            Secure Your<br />
            Digital Freedom
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto font-light">
            Military-grade encryption protecting your privacy across all devices with lightning-fast connection speeds
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg"
              onClick={() => scrollToSection('vpn')}
              className="min-w-48"
            >
              <i className="ri-play-circle-line mr-2"></i>
              Learn More
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => scrollToSection('contact')}
              className="min-w-48"
            >
              <i className="ri-customer-service-2-line mr-2"></i>
              Contact Us
            </Button>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('vpn')}
          className="text-white/70 hover:text-cyan-400 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
};
